/**
 * Spec §3.4 (D-6): a guest tile is rendered iff at least one media track is
 * active. A guest who closes both → tile vanishes (= moderator-invisible
 * mode). The host's own tile is governed by a different rule and stays
 * always-rendered with a placeholder; that rule is enforced inline at the
 * call site, not here.
 */
export function shouldRenderCohostTile(hasAudio: boolean, hasVideo: boolean): boolean {
  return hasAudio || hasVideo;
}
